import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Konto-area access:
 *  - Anonymous → bounce to /login (with redirect URL stashed)
 *  - Handwerker mit unfinished onboarding → /onboarding
 *  - Everyone else with a session → allowed
 */
export const kontoGuard: CanActivateFn = (_route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const platformId = inject(PLATFORM_ID);

  const user = authService.currentUser;

  if (user === null) {
    if (isPlatformBrowser(platformId)) {
      sessionStorage.setItem('craftly:redirectUrl', state.url);
    }
    return router.createUrlTree(['/login'], { queryParams: { redirect: state.url } });
  }

  if (user.rolle === 'Handwerker' && !user.onboardingAbgeschlossen) {
    return router.createUrlTree(['/onboarding']);
  }

  return true;
};
